<template>
    <resource-index title="Аренда" :endpoint="endpoint">
        <template v-slot:table-header>
            <tr class="border-b">
                <th class="text-left p-3 px-5" scope="col">Клиент</th>
                <th class="text-left p-3 px-5" scope="col">Стоимость</th>
                <th class="text-left p-3 px-5" scope="col">Окончание</th>
                <th class="text-left p-3 px-5" scope="col">Статус</th>
                <th class="text-left p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:row="slotProps">
            <td class="p-3 px-5">{{ slotProps.entry.customer.full_name }}</td>

            <td class="p-3 px-5">
                <span class="badge whitespace-no-wrap badge-success">{{ slotProps.entry.amount }} ₽</span>
            </td>

            <td class="p-3 px-5">{{ localTime(slotProps.entry.ends_at) }}</td>

            <td class="p-3 px-5">
                <span
                    class="badge whitespace-no-wrap badge-success"
                    v-if="slotProps.entry.returned_at"
                >Возвращен</span>
                <span
                    class="badge whitespace-no-wrap badge-danger"
                    v-else-if="slotProps.entry.is_expired"
                >Просрочен</span>
                <span
                    class="badge whitespace-no-wrap badge-warning"
                    v-else-if="slotProps.entry.return_soon"
                >&lt;3 дней</span>
                <span class="badge whitespace-no-wrap badge-indigo" v-else>Аренда</span>
            </td>

            <td class="p-3 px-5">
                <router-link
                    :to="{
                        name: 'admin.billing.rentals.edit',
                        params: {
                            id: slotProps.entry.id
                        }
                    }"
                    class="btn btn-info"
                >Открыть</router-link>
            </td>
        </template>
    </resource-index>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex
    },

    data() {
        return {
            endpoint: `/admin/products/${this.$route.params.id}/rentals`
        };
    },

    methods: {},

    mounted() {}
};
</script>